var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudysky(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 120,
    viewBox: "0 0 200 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.9 49H105.7C106.9 46 110.5 43.2 114.6 43.2C116.6 43.2 118.4 43.9 119.9 44.9C121.8 40.8 126.1 38 131.2 38C138 38 143.5 43.1 143.5 49.4C148 49.7 151.6 53.4 151.6 57.7C151.6 62.1 147.7 66 143 66H104.9C100.2 66 96.2998 61.9 96.2998 57.5C96.2998 53.1 100.1 49 104.9 49Z",
    fill: "#375CB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.8 58H117.6C115.7 53 110.5 49 104.3 49C101.4 49 98.5998 49.8 96.3998 51.3C93.5998 45.2 87.0998 41 79.5998 41C69.4998 41 61.2998 48.6 61.2998 57.9C54.5998 58.3 49.2998 63.6 49.2998 69.9C49.2998 76.5 54.9998 82 62.0998 82H118.8C125.9 82 131.6 76.6 131.6 70C131.7 63.4 125.9 58 118.8 58Z",
    fill: "#99CCFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudysky);
export default __webpack_public_path__ + "static/media/Cloudy sky.0d64e95e7b9161cea7f09b6357b5368d.svg";
export { ForwardRef as ReactComponent };